var captcha = false;
var grecaptchaSignup;
// https://www.regular-expressions.info/email.html
// A "practical implementation of RFC 5322".
var VALID_EMAIL_REGEX = /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

var onloadCallback = function () {
	grecaptchaSignup = grecaptcha.render("div_recaptcha", {
		sitekey: "6LeLGgQTAAAAAJpNKjbePCCoXL7cD5e-eF7pTb_p",
		callback: verifySignupCallback
	});
};

var verifySignupCallback = function (response) {
	if (response == null || response == "") {
		captcha = false;
	} else if (typeof response === undefined) {
		captcha = false;
	} else {
		captcha = true;
	}
	return captcha;
};


$(document).ready(function () {
	$("#requestIdsButton").click(function (e) {
		if (validateTaxId()) {
			taxId = $("#taxId1").val();
			requestIDs(taxId);
		}
	});

	$("#registerButton").click(function (e) {
		if (validateNewUserData()) {
			userName = $("#userName").val();
			dealerID = $("#dealerId").val();
			externalID = $("#externalId").val();
			password = $("#password").val();
			firstName = $("#firstName").val();
			lastName = $("#lastName").val();
			email = $("#eMail").val();

			registerUser(userName, dealerID, externalID, password, firstName, lastName, email);
		}
	});

	$("#emailResendButton").click(function () {
		if (validateEmail()) {
			email = $("#emailResend").val();
			resendEmailVerify(email);
		}
	});

	$("#ContactUsTopButton").click(function () {
		$("#ContactUsInformation").dialog({
			position: { my: "center", at: "center", of: window },
			draggable: false,
			resizable: true,
			height: 500,
			width: 500,
			buttons: {
				Close: function () {
					$(this).dialog("close");
				}
			},
			closeOnEscape: true,
			modal: true,
			close: function () {
				$(this).html("");
			}
		});
	});

	$("#AboutUsTopButton").click(function () {
		$("#AboutUsInformation").dialog({
			position: { my: "center", at: "center", of: window },
			draggable: false,
			resizable: true,
			height: 500,
			width: 500,
			buttons: {
				Close: function () {
					$(this).dialog("close");
				}
			},
			closeOnEscape: true,
			modal: true,
			close: function () {
				$(this).html("");
			}
		});
	});

	$("#FAQTopButton").click(function () {
		$("#FAQInformation").dialog({
			position: { my: "center", at: "center", of: window },
			draggable: false,
			resizable: true,
			height: 500,
			width: 500,
			buttons: {
				Close: function () {
					$(this).dialog("close");
				}
			},
			closeOnEscape: true,
			modal: true,
			close: function () {
				$(this).html("");
			}
		});
	});
});

function requestIDs(taxId) {
	$.ajax({
		method: "GET",
		url: "public/resources/forgot/ids",
		data: { TaxId: taxId },
		dataType: "json",
		success: function (result) {
			if (result.responseCode == "success") {
				document.getElementById("dealerId").value = result.dealerId;
				document.getElementById("externalId").value = result.externalId;
				$("#taxid-entry").hide();
				$("#register-info-entry").show();
			} else {
				alert("There was a problem with the request.");
			}
		},
		error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("There was a problem with the request.");
		}
	});
	return true;
}

function validateNewUserData() {
	var msg = [];
	var username = document.getElementById("userName").value;
	var email = document.getElementById("eMail").value;
	var pattern = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,16}$/g;
	var regexPass = new RegExp(pattern);
	var password1 = document.getElementById("password").value;
	var message = document.getElementById("confirmMessage");

	if (username == "") {
		msg.push("User Name is required.");
	} else if (username.search(/[^A-Za-z0-9_@\.]/) != -1) {
		msg.push("User Name contains special characters. Please only enter letters and numbers, or an email address.");
	}

	if (document.getElementById("firstName").value == "") {
		msg.push("First Name is required.");
	}

	if (document.getElementById("lastName").value == "") {
		msg.push("Last Name is required.");
	}

	if (email == "") {
		msg.push("Email is required.");
	} else if (VALID_EMAIL_REGEX.test(email) === false) {
		msg.push("Email address entered is invalid. Please ensure the email address entered is correct.");
	} else if (email != document.getElementById("confirmEMail").value) {
		msg.push("Email confirmation does not match. Please ensure the email address entered is correct.");
	}

	if (document.getElementById("dealerId").value == "") {
		msg.push("UACC Dealer Id is required.");
	}

	if (document.getElementById("externalId").value == "") {
		msg.push("UACC External Id is required.");
	}


	if (document.getElementById("password").value == "") {
		msg.push("Password is required.");
	} else if (document.getElementById("password2").value == "") {
		msg.push("Password confirmation is required.");
	} else if (($("#password").val()) != ($("#password2").val())) {
		msg.push("Password confirmation does not match. Please ensure the password entered is correct.");
	}

	if ($("#terms").is(":checked") == false) {
		msg.push("Please agree to the terms and conditions.");
	}

	if (captcha == false) {
		msg.push("The captcha was not completed. Please complete the captcha.");
	}

	if (regexPass.test(password1) == false) {
		msg.push("Password does not meet requirements. Please enter a password that is 8 to 16 characters, and includes at least one uppercase letter, one lowercase letter, one digit, and one non-alphanumeric character.");
	}

	if (msg.length > 0) {
		$("#popUpWarning").html(msg.join("<br>")).dialog({
			resizable: false,
			dialogClass: "alert-dialog",
			draggable: false,
			open: function () {
				$(this).parent().css({
					height: "auto",
					width: "40%",
					position: "fixed",
					left: "30%",
					top: 170
				});
			},
			buttons: {
				Ok: function () {	$(this).dialog("close");	}

			},
			title: "Error Message",
			closeOnEscape: true,
			modal: true
		});
		return false;
	}
	return true;
}

function registerUser(userName, dealerID, externalID, password, firstName, lastName, email) {
	$.ajax({
		method: "POST",
		url: "public/resources/register",
		data: {
			UserID: userName,
			DealerId: dealerID,
			ExternalId: externalID,
			Password: password,
			FirstNm: firstName,
			LastNm: lastName,
			Email: email
		},
		dataType: "json",
		success: function (result) {
			if (result.responseCode == "success") {
				$("#register-info-entry").hide();
				$("#register-error-notif").hide();
				$("#register-success-notif").show();
				$("#register-notif").show();

				document.getElementById("register-success-message").innerHTML = "We sent the email to: " + email;
			} else {
				document.getElementById("register-error-message").innerHTML = result.errorMessage;
				$("#register-info-entry").hide();
				$("#register-success-notif").hide();
				$("#register-error-notif").show();
				$("#register-notif").show();
			}
		},
		error: function (XMLHttpRequest, textStatus, errorThrown) {
			$("#register-info-entry").hide();
			$("#register-success-notif").hide();
			$("#register-error-notif").show();
			$("#register-notif").show();
		}
	});
	return true;
}

function resendEmailVerify(emailResend) {
	$.ajax({
		method: "GET",
		url: "public/resources/resendVerification",
		data: { Email: emailResend },
		dataType: "json",
		success: function (result) {
			if (result.responseCode == "success") {
				$("#resendConfirmMessage").html("Email has been resent.").css("color", "black");
			} else {
				var errorMsg = result.errorMessage;
				$("#resendConfirmMessage").html(errorMsg).css("color", "red");
				$("#emailResend").css("border", "1px solid red");
			}
		},
		error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("There was a problem with the request.");
		}
	});
	return true;
}


function validateEmail() {
	var flag = true;
	var msg = "";

	var email = $("#emailResend").val();
	var message = $("#resendConfirmMessage");
	message.html("");
	$("#emailResend").css("border", "1px solid #ccc");

	if (!email) {
		msg += "Please an email address. <br/>";
		$("#emailResend").css("border", "1px solid red");
		flag = false;
	}

	if (msg) {
		message.html(msg).css("color", "red");
	}

	return flag;
}


function validateTaxId() {
	var flag = true;
	var msg = "";

	var user1 = document.getElementById("taxId1").value;
	var user2 = document.getElementById("taxId2").value;
	var message = document.getElementById("taxIDConfirmMessage");
	message.innerHTML = "";


	if (user1 == "" && user2 == "") {
		msg += "Please enter your Tax ID number and a confirmation. <br/>";
		$("#taxId1").css("border", "1px solid red");
		flag = false;
	} else if (user1 == "") {
		msg += "Please enter your Tax ID number. <br/>";
		$("#taxId1").css("border", "1px solid red");
		flag = false;
	} else if (user2 == "") {
		msg = "Please enter the Confirmation Tax ID number. <br/>";
		$("#taxId2").css("border", "1px solid red");
		flag = false;
	} else if (user1.length != 9) {
		msg = "Please verify your Tax ID is 9 digits with no special characters. <br/>";
		$("#taxId1").css("border", "1px solid red");
		flag = false;
	} else if (user2.length != 9) {
		msg = "Please verify your Tax ID is 9 digits with no special characters. <br/>";
		$("#taxId2").css("border", "1px solid red");
		flag = false;
	} else if (user1 != user2) {
		msg = "The two IDs do not match. <br/>";
		$("#taxId1").css("border", "1px solid red");
		$("#taxId2").css("border", "1px solid red");
		flag = false;
	} else {
		$("#taxId1").css("border", "1px solid black");
		$("#taxId2").css("border", "1px solid black");
	}

	message.innerHTML = msg;

	return flag;
}

$(function () {
	$("#termsAndCond").click(function () {
		$("#termsDiv").dialog({
			draggable: false,
			resizable: false,
			height: "770",
			width: "75%",
			open: function () {
				$(this).parent().css({
					height: "770",
					width: "75%",
					position: "fixed",
					left: "12%",
					top: 100,
					overflow: "auto"
				});
				$(this).load("dealerPortalTermsOfUse.jsp");
			},

			buttons: {
				Close: function () {
					$(this).dialog("close");
				}
			},
			closeOnEscape: false,
			modal: true,
			close: function () {
				$(this).html("");
			}
		});
	});
});
